var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"title":_vm.$t('general.manage')}},[_c('InventoryInfo',{attrs:{"itemIdPublic":this.$route.params.idPublic}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }